export default __webpack_public_path__ + "static/media/790886726260359168.2c496544.png";